export enum AssetType {
  FIAT = 'fiat',
  CRYPTO = 'crypto',
}

export enum FiatCurrency {
  USD = 'USD',
  EUR = 'EUR',
  GBP = 'GBP',
  CHF = 'CHF',
  AED = 'AED',
}

export enum CryptoAsset {
  BTC = 'BTC',
  ETH = 'ETH',
  USDT = 'USDT',
  USDC = 'USDC',
  BNB = 'BNB',
}

export enum CryptoNetwork {
  ERC20 = 'ERC20',
  BEP20 = 'BEP20',
  BITCOIN_MAINNET = 'BITCOIN_MAINNET',
}

export enum AccountType {
  PERSONAL = 'personal',
  CORPORATE = 'corporate',
}

export enum AccountStatus {
  PENDING_KYC = 'pending_kyc',
  ACTIVE = 'active',
  SUSPENDED = 'suspended',
  CLOSED = 'closed',
}

export enum ApplicationStatus {
  DRAFT = 'DRAFT',
  SUBMITTED = 'SUBMITTED',
  UNDER_REVIEW = 'UNDER_REVIEW',
  ADDITIONAL_INFO_REQUIRED = 'ADDITIONAL_INFO_REQUIRED',
  APPROVED = 'APPROVED',
  REJECTED = 'REJECTED',
}

export enum RiskLevel {
  LOW = 'LOW',
  MEDIUM = 'MEDIUM',
  HIGH = 'HIGH',
  CRITICAL = 'CRITICAL',
}

export enum TransactionStatus {
  PENDING = 'PENDING',
  PROCESSING = 'PROCESSING',
  COMPLETED = 'COMPLETED',
  FAILED = 'FAILED',
  CANCELLED = 'CANCELLED',
  REVERSED = 'REVERSED',
}

export enum TransactionType {
  DEPOSIT = 'DEPOSIT',
  WITHDRAWAL = 'WITHDRAWAL',
  TRANSFER = 'TRANSFER',
  FEE = 'FEE',
  CONVERSION = 'CONVERSION',
}

export enum PaymentChannel {
  SEPA = 'SEPA',
  SWIFT = 'SWIFT',
  CRYPTO = 'CRYPTO',
  INTERNAL = 'INTERNAL',
}

export enum UserRole {
  PERSONAL_CLIENT = 'PERSONAL_CLIENT',
  CORPORATE_CLIENT = 'CORPORATE_CLIENT',
  SUPER_ADMIN = 'SUPER_ADMIN',
  APPROVER = 'APPROVER',
  ADMINISTRATOR = 'ADMINISTRATOR',
  COMPLIANCE_OFFICER = 'COMPLIANCE_OFFICER',
  SYSTEM_OPERATOR = 'SYSTEM_OPERATOR',
}

export enum ApprovalStatus {
  PENDING = 'PENDING',
  APPROVED = 'APPROVED',
  REJECTED = 'REJECTED',
}

export enum BeneficiaryType {
  INDIVIDUAL = 'INDIVIDUAL',
  CORPORATE = 'CORPORATE',
}
